import Formulario from './Formulario';
import ChatAdmin from './ChatAdmin';
import AuthForm from './AuthForm';
// import { auth, provider } from './firebaseConfig';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import SEO from './SEO';

function Publicar({ user }) {
  const [showChat, setShowChat] = useState(false);
  const [selectedTier, setSelectedTier] = useState('Gratuito');

  return (
    <div className="min-h-screen bg-black text-white max-w-5xl mx-auto p-6 md:p-10 font-josefin">
      <SEO
        title="Publicar Anuncio | VipEncuentros"
        description="Publica tu anuncio en VipEncuentros, el sitio líder de scorts masculinos en Chile. Llega a miles de clientes reales."
        keywords="publicar anuncio scort, publicidad scort, vipencuentros publicar"
        url="https://vipencuentros.com/publicar"
      />
      <Link to="/" className="text-blue-400 hover:text-blue-300 transition-colors underline text-sm inline-flex items-center gap-1 mb-8">
        &larr; Volver al Inicio
      </Link>

      <header className="mb-12">
        <h1 className="text-4xl md:text-5xl font-black mb-4 bg-gradient-to-r from-yellow-500 via-yellow-200 to-yellow-600 bg-clip-text text-transparent uppercase tracking-tight">
          Publica con Nosotros
        </h1>
        <p className="text-gray-400 text-lg max-w-2xl leading-relaxed">
          Nuestra plataforma se publicita constantemente en redes sociales y lugares estratégicos de la ciudad (bares, discotecas, baños) para asegurar que tu perfil llegue a miles de ojos diariamente.
        </p>
      </header>

      {/* SECCIÓN DE MEMBRESÍAS */}
      <section className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        {/* FREE */}
        <div
          onClick={() => setSelectedTier('Gratuito')}
          className={`cursor-pointer p-6 rounded-2xl shadow-xl transition-all group border-2 ${selectedTier === 'Gratuito' ? 'bg-neutral-800 border-blue-500 scale-[1.02]' : 'bg-neutral-900 border-neutral-800 hover:border-blue-500/30'}`}
        >
          <div className="flex justify-between items-start mb-4">
            <div className="text-blue-500">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-10 h-10">
                <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21c-2.676 0-5.216-.584-7.499-1.632z" />
              </svg>
            </div>
            {selectedTier === 'Gratuito' && <span className="bg-blue-500 text-white text-[10px] font-bold px-2 py-0.5 rounded-full uppercase">Seleccionado</span>}
          </div>
          <h3 className="text-xl font-bold mb-2">Nivel FREE</h3>
          <p className="text-gray-400 text-sm mb-4 leading-relaxed">
            Publicación estándar. Tu perfil aparecerá en la parte inferior y estará sujeto a una **revisión previa del administrador** antes de ser visible.
          </p>
          <ul className="text-xs text-gray-500 space-y-2 mb-6">
            <li className="flex items-center gap-2">✅ Visibilidad básica</li>
            <li className="flex items-center gap-2">✅ Subida de fotos</li>
          </ul>
        </div>

        {/* Semi VIP */}
        <div
          onClick={() => setSelectedTier('Semi VIP')}
          className={`cursor-pointer p-6 rounded-2xl shadow-xl transition-all relative z-10 border-2 ${selectedTier === 'Semi VIP' ? 'bg-neutral-800 border-purple-500 scale-[1.02]' : 'bg-neutral-900 border-neutral-800 hover:border-purple-500/30'}`}
        >
          <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-purple-600 text-white text-[10px] font-bold px-3 py-1 rounded-full uppercase tracking-widest">
            Recomendado
          </div>
          <div className="flex justify-between items-start mb-4">
            <div className="text-purple-500">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-10 h-10">
                <path strokeLinecap="round" strokeLinejoin="round" d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z" />
              </svg>
            </div>
            {selectedTier === 'Semi VIP' && <span className="bg-purple-500 text-white text-[10px] font-bold px-2 py-0.5 rounded-full uppercase">Seleccionado</span>}
          </div>
          <h3 className="text-xl font-bold mb-2 text-purple-400">Semi VIP</h3>
          <p className="text-gray-400 text-sm mb-4 leading-relaxed">
            Mejora tu visibilidad de forma económica. Este es un **plan semanal de pago** que te permite destacar sobre los perfiles gratuitos.
          </p>
          <ul className="text-xs text-gray-500 space-y-2 mb-6">
            <li className="flex items-center gap-2">✅ Posición media destacada</li>
            <li className="flex items-center gap-2">✅ Mayor tamaño de tarjeta</li>
            <li className="flex items-center gap-2 text-purple-300">⭐ Pago Semanal</li>
          </ul>
        </div>

        {/* VIP */}
        <div
          onClick={() => setSelectedTier('VIP')}
          className={`cursor-pointer p-6 rounded-2xl shadow-2xl transition-all group border-2 ${selectedTier === 'VIP' ? 'bg-neutral-800 border-yellow-500 scale-[1.02]' : 'bg-neutral-900 border-neutral-800 hover:border-yellow-500/40'}`}
        >
          <div className="flex justify-between items-start mb-4">
            <div className="text-yellow-500">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-10 h-10">
                <path strokeLinecap="round" strokeLinejoin="round" d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.923 20.91a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z" />
              </svg>
            </div>
            {selectedTier === 'VIP' && <span className="bg-yellow-500 text-black text-[10px] font-bold px-2 py-0.5 rounded-full uppercase">Seleccionado</span>}
          </div>
          <h3 className="text-xl font-bold mb-2 text-yellow-500 uppercase tracking-widest">VIP</h3>
          <p className="text-gray-400 text-sm mb-4 leading-relaxed">
            Máxima exclusividad y prioridad total. El perfil más grande al inicio de la página. **Plan semanal de alto impacto.**
          </p>
          <ul className="text-xs text-gray-500 space-y-2">
            <li className="flex items-center gap-2 font-bold text-yellow-500/80">🏆 Posición TOP 1</li>
            <li className="flex items-center gap-2">✅ Tamaño Extra Grande</li>
          </ul>
        </div>
      </section>

      <div className="bg-neutral-900/80 border border-neutral-800 p-4 rounded-xl mb-12 flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="text-gray-300 text-sm flex items-center gap-2 text-shadow-none">
          <span className="text-yellow-500 text-xl">💡</span>
          ¿Tienes dudas sobre los precios de cada plan? Contáctanos directamente por el chat interno (no necesitas cuenta).
        </p>
        <button
          onClick={() => setShowChat(true)}
          className="bg-yellow-600 hover:bg-yellow-500 text-white font-bold px-6 py-2 rounded-full transition shadow-lg text-sm flex items-center gap-2 whitespace-nowrap"
        >
          💬 Hablar con Soporte
        </button>
      </div>

      {/* FORMULARIO O CHAT */}
      <section className="bg-neutral-900/50 p-8 rounded-3xl border border-neutral-800 shadow-2xl relative overflow-hidden">
        <div className="absolute top-0 right-0 w-64 h-64 bg-yellow-500/5 blur-[100px] rounded-full pointer-events-none"></div>
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-blue-500/5 blur-[100px] rounded-full pointer-events-none"></div>

        <div className="relative z-10 text-shadow-none">
          <div className="flex justify-between items-center mb-10">
            <h2 className="text-2xl font-bold capitalize">
              {showChat ? 'Chat con el Administrador' : (user ? `Publicación ${selectedTier}` : 'Acceso Registrado')}
            </h2>
            <button
              onClick={() => setShowChat(!showChat)}
              className="text-sm font-bold text-yellow-500 hover:text-yellow-400 flex items-center gap-2 underline underline-offset-4"
            >
              {showChat ? 'Volver' : 'Tengo dudas (Chat)'}
            </button>
          </div>

          {showChat ? (
            <ChatAdmin user={user} />
          ) : (
            <>
              {!user ? (
                <div className="text-center py-4">
                  <p className="mb-8 text-gray-400 max-w-md mx-auto line-height-relaxed">
                    Para publicar tu perfil, por favor crea una cuenta o ingresa con tus datos.
                  </p>
                  <AuthForm />
                </div>
              ) : (
                <Formulario user={user} selectedMembresia={selectedTier} />
              )}
            </>
          )}

          {!showChat && (
            <p className="mt-8 text-xs text-gray-500 text-center leading-relaxed">
              Al publicar, confirmas ser mayor de 18 años. <br />
              Todos los perfiles pasan por una revisión de hasta 24 horas.
            </p>
          )}
        </div>
      </section>
    </div>
  );
}

export default Publicar;
